<template>
  <div>
    <div class="analysis-chart">
      <div class="analysis-chart mar-b-40">
        <div class="relative">
          <div class="ipub-p1 "
               style="text-align:center;font-size:16px">Manuscript in total</div>
          <div class="flex"
               style="width:auto;align-items: center;justify-content: center;height:300px;"
               id="ManuscriptChart-submit">
          </div>

        </div>
        <div class="type-item">
          <div class="flex mar-b-8 ipub-p2 type-item-item"
               v-for="(item,index) in typeSubmit"
               :key="'type'+index">
            <div class="flex ipub-p2"
                 style="align-items: center;width: calc(100% - 50px)">
              <span class="item-radio"
                    :style="{background:colorType[index]}"></span>
              <span class="type-item-text">{{item.name}} | {{((item.value===0 || total2===0)?0:item.value/total2 *100).toFixed(0)}}%</span>
            </div>
            <span class="mar-l-10">{{item.value}}</span>
          </div>
        </div>
      </div>
      <div class="relative">
        <div class="ipub-p1 "
             style="text-align:center;font-size:16px">Acceptance in total</div>
        <div class="flex"
             style="width:auto;align-items: center;justify-content: center;height:300px;"
             id="ManuscriptChart-accept">
        </div>

      </div>
      <div class="type-item">
        <span class="flex mar-b-10 ipub-p2 type-item-item"
              v-for="(item,index) in typeAccept"
              :key="'type'+index">
          <span class="flex ipub-p2">
            <span class="item-radio"
                  :style="{background:colorType[index]}"></span>
            {{item.name}} | {{((item.value===0 || total1===0)?0:item.value/total1 *100).toFixed(0)}}%
          </span>
          <span>{{item.value}}</span>
        </span>
      </div>
    </div>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'
// import echarts from 'echarts'
import { statisticMcountry, statisticMtype } from '@/api/statistic'

export default {
  props: {
    artical: {
      type: Number,
      default: 1
    },
    journalId: {
      type: String,
      default: ''
    },
    startDate: {
      type: [Object, String],
      default () {
        return {}
      }
    },
    endDate: {
      type: [Object, String],
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      start: 0,
      total1: 0,
      total2: 0,
      params: {},
      tType: '',
      // 数据
      typeAccept: [],
      typeSubmit: [],
      // 颜色 分类
      colorType: ['#1F299C', '#16215B', '#0373FF', '#02457A', '#30D1FF', '#018ABE', '#97CADB', '#787CA9', '#A3A9F5', '#D6E8EE', '#E0EAF8'],
      ifShow: true,
      option1: {},
      option2: {},
    }
  },
  computed: {
    ...mapGetters({
      showMenus: 'getShowMenus',
      country: 'getCountry',
      manuscriptType: 'getManuscriptType',
    })
  },
  watch: {
    showMenus (newV) {
      this.ifShow = newV
    },
    artical: {
      handler (newV) {
        this.getData(this.journalId, this.startDate, this.endDate, newV)
      }
    },
    journalId: {
      handler (newV) {
        if (newV) {
          this.getData(newV, this.startDate, this.endDate, this.artical)
        }
      },
      immediate: true
    }, startDate: {
      handler (newV) {
        this.getData(this.journalId, newV, this.endDate, this.artical)
      }
    }, endDate: {
      handler (newV) {
        this.getData(this.journalId, this.startDate, newV, this.artical)
      }
    }
  },
  async mounted () {
    // this.getData(this.journalId, this.startDate, this.endDate, this.artical)

  },
  methods: {

    async getData (journalId, accessDateStart, accessDateEnd, artical) {
      this.typeAccept = []
      this.typeSubmit = []
      let typeAccept = []
      let typeSubmit = []
      this.total1 = 0
      this.total2 = 0
      let res1 = []
      let res2 = []
      let data = {
        journalId,
        accessDateStart,
        accessDateEnd
      }
      if (artical === 1) {
        res1 = await statisticMcountry.mcountry('accept', data)
        res2 = await statisticMcountry.mcountry('submit', data)

      } else {
        res1 = await statisticMtype.mcountry('accept', data)
        res2 = await statisticMtype.mcountry('submit', data)

      }

      let otherTotal1 = 0
      let otherTotal2 = 0
      res1 && res1.map((item, index) => {
        if (index < 10) {
          typeAccept.push({
            value: item.acceptNum || 0,
            name: artical === 1 ? this.country[item.countryCode] : this.manuscriptType[item.typeCode]
          })
        } else {
          otherTotal1 += (item.acceptNum || 0)
        }
      })
      if (res1.length > 10) {
        typeAccept.push({
          value: otherTotal1,
          name: 'other'
        })
      }
      typeAccept.map(item => {
        this.total1 += item.value || 0
      })
      this.typeAccept = typeAccept

      res2 && res2.map((item, index) => {
        // if (countryArr.includes(this.country[item.countryCode])) {
        if (index < 10) {
          typeSubmit.push({
            value: item.submitNum || 0,
            name: artical === 1 ? this.country[item.countryCode] : this.manuscriptType[item.typeCode]
          })
        } else {
          otherTotal2 += (item.submitNum || 0)
        }
      })
      if (res2 && res2.length > 10) {
        typeSubmit.push({
          value: otherTotal2,
          name: 'other'
        })
      }

      typeSubmit.map(item => {
        this.total2 += item.value || 0
      })
      this.typeSubmit = typeSubmit

      this.optionType()
    },
    getEchart () {
      var echarts = require('echarts')
      let myChart = {}
      myChart['accept'] = echarts.init(document.getElementById('ManuscriptChart-accept'))
      myChart['submit'] = echarts.init(document.getElementById('ManuscriptChart-submit'))
      myChart['accept'].setOption(this.option1)
      myChart['submit'].setOption(this.option2)
    },
    optionType () {
      this.option1 = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            let res = `<div>${params.name}</div><span>${params.percent}%</span> / <span>${params.value}</span>`
            return res
          },
          extraCssText: 'background: #fff; border-radius: 2px;color: #1E1D40;border: 1px solid #1E1D40;font-size:12px;padding:2px 8px'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '80%'],
            center: ['50%', '48%'],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
              emphasis: {//对应的鼠标悬浮效果
                show: true,
                // textStyle: { color: "#FFFFFF" },
                // color: '#004989'
              },
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            color: this.colorType,
            data: this.typeAccept
          }
        ]
      }
      this.option2 = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            let res = `<div>${params.name}</div><span>${params.percent}%</span> / <span>${params.value}</span>`
            return res
          },
          extraCssText: 'background: #fff; border-radius: 2px;color: #1E1D40;border: 1px solid #1E1D40;font-size:12px;padding:2px 8px'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '80%'],
            center: ['50%', '48%'],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
              emphasis: {//对应的鼠标悬浮效果
                show: true,
                // textStyle: { color: "#FFFFFF" },
                // color: '#004989'
              },
            },
            label: {
              show: false,
              position: 'center',
            },
            labelLine: {
              show: false
            },

            color: this.colorType,
            data: this.typeSubmit
          }
        ]
      }
      this.getEchart()
    },

  }
}
</script>

<style lang="scss" scoped>
.item-radio {
  width: 17px;
  height: 17px;
  min-width: 17px;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}
.type-item {
  // overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  &-item {
    align-items: center;
    justify-content: space-between;
    width: 47%;
    margin-right: 12px;
  }
  &-item:nth-child(2n) {
    margin-right: 0;
  }
  &-text {
    word-wrap: break-word;
  }
}
</style>
